// jshint esversion: 6
import {
	DRIVE_CLIENT_ID
} from './private';

function recursive(index, array, networkTask, resultTask, endRecursion) {
	if (array[index]) {
		new Promise(function (resolve) {
			// console.time("sequence")
			networkTask(array[index], resolve, index);
		}).then(function (result) {
			// console.timeEnd("sequence")
			if (typeof resultTask === "function") {
				resultTask(result, array[index], index);
			}
			recursive(index + 1, array, networkTask, resultTask, endRecursion);
		});
	} else {
		endRecursion();
	}
}

function sequence(array, networkTask, resultTask) {
	return new Promise(function (resolve) {
		recursive(0, array, networkTask, resultTask, resolve);
	});
}

import localforage from 'localforage'

let drive = {
	auth: {
		// replace this with your api key.
		// if you try using this key, your app won't work since it's not coming from the right origin.
		// we need to whitelist your origin, and then we provide you with a key.
		client_id: DRIVE_CLIENT_ID,
		scope: 'https://www.googleapis.com/auth/drive.appfolder',
		immediate: true
	},
	files: {
		options: {
			name: "Options",
			id: null,
			date: "",
			local: null,
			data: {}
		},
		history1: {
			name: "HistoryXBOX",
			id: null,
			date: "",
			local: null,
			data: {}
		},
		history2: {
			name: "HistoryPSN",
			id: null,
			date: "",
			local: null,
			data: {}
		},
		history4: {
			name: "HistoryBLIZZARD",
			id: null,
			date: "",
			local: null,
			data: {}
		},
		profiles: {
			name: "Profiles",
			id: null,
			date: "",
			local: null,
			data: {}
		}
	},
	// create a file in the appDataFolder
	// file is named 'Open.Loadout'
	createFile: function createFile(fileDetails) {
		console.log(`CREATE_FILE ${fileDetails.name}`);
		return new Promise(function (resolve) {
			gapi.client.drive.files.create({
				fields: 'id,modifiedTime',
				resource: {
					mimeType: 'application/json',
					name: fileDetails.name,
					parents: ['appDataFolder']
				}
			}).then(function (response) {
				console.log(`CREATE_FILE ${fileDetails.name}`, response);
				if (response && response.result) {
					fileDetails.id = response.result.id;
					fileDetails.date = response.result.modifiedTime;
					resolve(fileDetails);
				}
			}, function (err) {
				console.error(`CREATE_FILE ${fileDetails.name}`, err);
				resolve(fileDetails);
			});
			// gapi.client.request({
			// 	path: `upload/drive/v3/files`,
			// 	method: 'POST',
			// 	resource: {
			// 		name: fileDetails.name,
			// 		parents: ['appDataFolder']
			// 	},
			// 	params: {
			// 		uploadType: 'media',
			// 		fields: 'id,modifiedTime',
			// 	}
			// }).then(function (response) {
			// 	console.log(`CREATE_FILE ${fileDetails.name}`, response);
			// 	if (response && response.id) {
			// 		fileDetails.id = response.id;
			// 		fileDetails.date = response.modifiedTime;
			// 		resolve(fileDetails);
			// 	}
			// }, function (err) {
			// 	console.error(`CREATE_FILE ${fileDetails.name}`, err);
			// 	resolve(fileDetails);
			// });
		});
	},
	// list all the files in the appDataFolder
	// that match the name 'Open.Loadout' (hopefully just one...)
	getFileId: function getFileId(fileDetails) {
		console.log(`GET_FILE_ID ${fileDetails.name}`);
		return new Promise(function (resolve) {
			if (fileDetails.id) {
				resolve(fileDetails);
			} else {
				gapi.client.request({
					path: `/drive/v3/files`,
					method: 'GET',
					params: {
						q: `name="${fileDetails.name}"`,
						spaces: 'appDataFolder',
						fields: 'files(id,modifiedTime)'
					}
				}).then(function (response) {
					console.log(`GET_FILE_ID ${fileDetails.name}`, response);
					if (!response || !response.files.length) {
						drive.createFile(fileDetails).then(resolve);
					} else {
						fileDetails.id = response.files[0].id;
						resolve(fileDetails);
					}
				}, function (err) {
					console.error(`GET_FILE_ID ${fileDetails.name}`, err);
					resolve(fileDetails);
				});
			}
		});
	},
	getAllFileMetaData: function getAllFileMetaData() {
		console.log(`GET_ALL_FILE_METADATA`);
		return new Promise(function (resolve) {
			gapi.client.request({
				path: `/drive/v3/files`,
				method: 'GET',
				params: {
					spaces: 'appDataFolder',
					fields: 'files(id,modifiedTime,name)'
				}
			}).then(function (response) {
				console.log(`GET_ALL_FILE_METADATA`, response);
				resolve(response.result);
			}, function (err) {
				console.error(`GET_ALL_FILE_METADATA`, err);
				resolve();
			});
		});
	},
	getFile: function getFile(fileDetails) {
		console.log(`GET_FILE ${fileDetails.name}`);
		return new Promise(function (resolve) {
			drive.getFileDate(fileDetails).then(function (date) {
				if (date !== fileDetails.date) {
					fileDetails.date = date;
					gapi.client.request({
						path: `/drive/v3/files/${fileDetails.id}`,
						method: 'GET',
						params: {
							alt: 'media'
						}
					}).then(function (response) {
						console.log(`GET_FILE ${fileDetails.name}`, response);
						if (response && response.result) {
							fileDetails.data = response.result;
							fileDetails.local.setItem('data', response.result).then(function (value) {
								// Do other things once the value has been saved.
								resolve(fileDetails);
							}).catch(function (err) {
								// This code runs if there were any errors
								console.log(err);
								resolve(fileDetails);
							});
						} else {
							setTimeout(function () {
								resolve(drive.forceGetFile(fileDetails));
							}, 500);
						}
					}, function (err) {
						console.error(`GET_FILE ${fileDetails.name}`, err);
						resolve(fileDetails);
					});
				} else {
					resolve(fileDetails);
				}
			}, function (err) {
				console.error(`GET_FILE ${fileDetails.name}`, err);
				resolve(fileDetails);
			});
		});
	},
	forceGetFile: function forceGetFile(fileDetails) {
		return new Promise(function (resolve) {
			console.log(`FORCE_GET_FILE ${fileDetails.name}`);
			gapi.client.request({
				path: `/drive/v3/files/${fileDetails.id}`,
				method: 'GET',
				params: {
					alt: 'media'
				}
			}).then(function (response) {
				console.log(`FORCE_GET_FILE ${fileDetails.name}`, response);
				if (response && response.result) {
					fileDetails.data = response.result;
					fileDetails.local.setItem('data', response.result).then(function (value) {
						// Do other things once the value has been saved.
						resolve(fileDetails);
					}).catch(function (err) {
						// This code runs if there were any errors
						console.log(err);
						resolve(fileDetails);
					});
				} else {
					resolve(fileDetails);
				}
			}, function (err) {
				console.error(`FORCE_GET_FILE ${fileDetails.name}`, err);
				resolve(fileDetails);
			});
		});
	},
	getAllFiles: function getAllFiles() {
		return new Promise(function (resolve) {
			let allFiles = [];
			for (let fileIdentifier in drive.files) {
				let fileDetails = drive.files[fileIdentifier];
				allFiles.push(drive.forceGetFile(fileDetails));
			}
			Promise.all(allFiles).then(resolve);
		});
	},
	getFileDate: function getFileDate(fileDetails) {
		console.log(`GET_FILE_DATE ${fileDetails.name}`);
		return new Promise(function (resolve) {
			gapi.client.request({
				path: `/drive/v3/files/${fileDetails.id}`,
				method: 'GET',
				params: {
					fields: 'modifiedTime',
					alt: 'json'
				}
			}).then(function (response) {
				console.log(`GET_FILE_DATE ${fileDetails.name}`, response);
				resolve(response.result.modifiedTime);
			}, function (err) {
				console.error(`GET_FILE_DATE ${fileDetails.name}`, err);
				if (err.status === 401) {
					console.trace();
					drive.postAuth(resolve);
					gapi.auth.authorize(drive.auth, drive.refresh);
				} else {
					resolve(fileDetails);
				}
				// resolve(fileDetails);
			});
		});
	},
	editFile: function editFile(fileDetails) {
		console.log(`EDIT_FILE ${fileDetails.name}`);
		return new Promise(function (resolve) {
			gapi.client.request({
				path: `/upload/drive/v3/files/${fileDetails.id}`,
				method: 'PATCH',
				params: {
					uploadType: 'media',
					alt: 'json',
					fields: 'modifiedTime'
				},
				body: JSON.stringify(fileDetails.data)
			}).then(function (response) {
				console.log(response)
				fileDetails.date = response.result.modifiedTime;
				fileDetails.local.setItem('date', response.result.modifiedTime).then(function (value) {
					// Do other things once the value has been saved.
					fileDetails.local.setItem('data', fileDetails.data).then(function () {
						// Do other things once the value has been saved.
						resolve(fileDetails);
					}).catch(function (err) {
						// This code runs if there were any errors
						console.log(err);
						resolve(fileDetails);
					});
				}).catch(function (err) {
					// This code runs if there were any errors
					console.error(err);
					resolve(fileDetails);
				});
			}, function (err) {
				console.error(`EDIT_FILE ${fileDetails.name}`, err);
				resolve(fileDetails);
			});
		});
	},
	loadLocalData: function loadLocalData(fileDetails, complete) {
		fileDetails.local = localforage.createInstance({
			name: fileDetails.name
		});
		fileDetails.local.getItem("id", function (err, idValue) {
			if (err) {
				console.error(err);
				complete();
			}
			if (idValue) {
				fileDetails.id = idValue;
			}
			fileDetails.local.getItem("date", function (err, dateValue) {
				if (err) {
					console.error(err);
					complete();
				}
				if (dateValue) {
					fileDetails.date = dateValue;
				}
				fileDetails.local.getItem("data", function (err, dataValue) {
					if (err) {
						console.error(err);
						complete();
					}
					console.warn(fileDetails, idValue, dateValue, dataValue)
					if (dataValue) {
						fileDetails.data = dataValue;
					}
					complete();
				});
			});
		});
	},
	// the main flow after authentication
	refresh: function refresh(authResult) {
		console.log(authResult)
		if (authResult && !authResult.error) {

			// Access token has been successfully retrieved, requests can be sent to the API.

			// load google
			gapi.client.load('drive', 'v3', function () {
				let fileDetailsList = [];
				for (let fileId of Object.keys(drive.files)) {
					fileDetailsList.push(drive.files[fileId]);
				}
				sequence(fileDetailsList, drive.loadLocalData).then(function () {
					console.log(fileDetailsList);
					drive.getAllFileMetaData().then(function (data) {
						if (data && data.files) {
							let missingFiles = [];
							let oldFiles = [];
							for (let fileIdentifier in drive.files) {
								let fileDetails = drive.files[fileIdentifier];
								for (let file of data.files) {
									if (fileDetails.name === file.name) {
										if (!fileDetails.date || !fileDetails.id) {
											fileDetails.id = file.id;
											fileDetails.date = file.modifiedTime;
											fileDetails.local.setItem("id", fileDetails.id);
											fileDetails.local.setItem("date", fileDetails.date);
										} else if (new Date(fileDetails.date).getTime() < new Date(file.modifiedTime).getTime() || Object.keys(fileDetails.data).length === 0) {
											oldFiles.push(drive.forceGetFile(fileDetails));
										}
										break;
									}
								}
								if (!fileDetails.id) {
									missingFiles.push(drive.createFile(fileDetails));
								}
								if (!fileDetails.data) {
									oldFiles.push(drive.forceGetFile(fileDetails));
								}
							}
							console.log(missingFiles, oldFiles, drive.files)
							Promise.all(missingFiles).then(function () {
								Promise.all(oldFiles).then(function (values) {
									console.log("Drive Files", values);
									drive.postAuth(null, true);
								});
							});
						} else {
							console.trace();
							// drive.refresh(authResult);
						}
					});
				});
			});
		} else {
			console.trace();
			// No access token could be retrieved, show the button to start the authorization flow.
			if (process.env.NODE_ENV === "web") {
				drive.authError(null, true);
			} else {
				drive.auth.immediate = false;
				gapi.auth.authorize(drive.auth, drive.refresh);
			}
		}
	},
	postAuth: (function () {
		let postAuthList = [];
		let driveReady = false;
		return function (fn, ready) {
			if (typeof ready !== "undefined") {
				driveReady = ready;
			}
			if (fn) {
				postAuthList.push(fn);
			}
			if (driveReady) {
				for (let postAuthFn of postAuthList) {
					postAuthFn();
				}
				postAuthList = [];
			}
		};
	}()),
	authError: (function () {
		let authErrorList = [];
		let driveReady = false;
		return function (fn, ready) {
			if (typeof ready !== "undefined") {
				driveReady = ready;
			}
			if (fn) {
				authErrorList.push(fn);
			}
			if (driveReady) {
				for (let authErrorFn of authErrorList) {
					authErrorFn();
				}
				authErrorList = [];
				driveReady = false;
				drive.postAuth(null, false);
			}
		};
	}())
};

export default {
	postAuth: drive.postAuth,
	authError: drive.authError,
	auth: drive.auth,
	files: drive.files,
	createFile: drive.createFile,
	getFileId: drive.getFileId,
	getFile: drive.getFile,
	editFile: drive.editFile,
	getFileDate: drive.getFileDate,
	getAllFileMetaData: drive.getAllFileMetaData,
	forceGetFile: drive.forceGetFile,
	getAllFiles: drive.getAllFiles,
	refresh: drive.refresh
};


// WEBPACK FOOTER //
// ./src/shared/drive.js